import React from 'react';
export function TomoCards() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const tomos = [{
    color: 'bg-red-600',
    border: 'border-red-700',
    title: 'Fundamentos',
    emoji: '🏋️'
  }, {
    color: 'bg-blue-600',
    border: 'border-blue-700',
    title: 'Ejercicios',
    emoji: '💪'
  }, {
    color: 'bg-purple-600',
    border: 'border-purple-700',
    title: 'Principiantes',
    emoji: '🟢'
  }, {
    color: 'bg-green-600',
    border: 'border-green-700',
    title: 'Intermedias',
    emoji: '⚡'
  }, {
    color: 'bg-yellow-500',
    border: 'border-yellow-600',
    title: 'Avanzadas',
    emoji: '🔥'
  }, {
    color: 'bg-[#FF6B00]',
    border: 'border-[#cc5500]',
    title: 'Programación',
    emoji: '📊'
  }];
  return <section className="bg-[#F5F5F5] py-3 px-3 border-b border-gray-200" data-id="element-174">
      <div className="max-w-4xl mx-auto" data-id="element-175">
        <h3 className="text-center text-[#0B1F3A] font-black uppercase tracking-widest mb-2 text-xs md:text-sm" data-id="element-176">
          📘 VISTA RÁPIDA DE LOS 6 TOMOS
        </h3>
        <div className="flex gap-1.5 overflow-x-auto pb-1 scrollbar-hide" data-id="element-177">
          {tomos.map((tomo, i) => <div key={i} onClick={scrollToPricing} className={`${tomo.color} ${tomo.border} border-b-3 rounded-lg p-2 text-center cursor-pointer transform hover:-translate-y-1 transition-transform duration-300 shadow-sm flex-shrink-0 w-[72px] md:w-24 flex flex-col justify-center items-center`} data-id="element-178">
              <div className="text-xl mb-0.5" data-id="element-179">{tomo.emoji}</div>
              <h4 className="text-white font-black text-[10px] md:text-xs leading-tight" data-id="element-180">
                {tomo.title}
              </h4>
            </div>)}
        </div>
      </div>
    </section>;
}